import {
  Checkbox,
  TableCell,
  TableHead as MuiTableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import PropTypes from "prop-types";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import React from "react";
import { useTranslation } from "react-i18next";

const EnhancedTableHead = (props) => {
  const { t } = useTranslation();
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    updatedHeadCells,
    checkBox,
    setChecked,
  } = props;
  const createSortHandler = (property, field = null) => (event) => {
    onRequestSort(event, property, field);
  };
  const handleChange = () => {
    setChecked();
  };

  if (setChecked !== undefined) {
    updatedHeadCells.unshift({
      id: "check",
      label: (
        <Checkbox
          checkedIcon={<CheckBoxOutlinedIcon />}
          size="small"
          color="default"
          checked={checkBox}
          onChange={handleChange}
          className={classes.checkBox}
        />
      ),
    });
  }

  return (
    <MuiTableHead>
      <TableRow>
        {updatedHeadCells.map((headCell) => {
          let checkBoxCell = headCell.id === "check";
          if (headCell.hidden){
            return null;
          }
          return (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              sortDirection={orderBy === headCell.id ? order : false}
              className={checkBoxCell ? classes.checkBoxTableCell : null}
            >
              {checkBoxCell ? (
                headCell.label
              ) : (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(
                    headCell.id,
                    headCell.order ? headCell.order : null
                  )}
                >
                  {t(headCell.label)}
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                </TableSortLabel>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </MuiTableHead>
  );
};

EnhancedTableHead.propTypes = {
  classes: PropTypes.object,
  onRequestSort: PropTypes.func,
  order: PropTypes.oneOf(["asc", "desc"]),
  orderBy: PropTypes.string,
  updatedHeadCells: PropTypes.array,
  checkBox: PropTypes.bool,
  setChecked: PropTypes.func,
};

export default EnhancedTableHead;
